module.exports = ".tamano-carta-block{\n  width: 100%;\n}\n\n.activeColor {\n    background-color: rgb(126,211,33);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/members/member-detail/member-detail.component.css
// module id = ./src/app/admin/pages/members/member-detail/member-detail.component.css
// module chunks = main